<template>
  <div class="wrap p-t-lg">
    <div class="container">
      <div class="p-t-md">
        <div class="row">
          <!-- loading -->
          <loading v-if="loading === 1" style="min-height:620px;"></loading>
          <!-- loading -->
          <div class="evaluate n-m-t" v-show="loading === 0">
            <h1 class="title">{{(company&&company._id?(evaluate.alias?evaluate.alias:evaluate.name):evaluate.name)+(company&&company._id?('-'+company.name):'')}}</h1>
            <div class="infos">
              <span class="item">{{evaluate.evaluate_num}}人测试过</span>
              <span class="item hidden-xs">{{evaluate.create_at|format}}发布</span>
              <span class="item right">本次测试共
                <span class="num">{{evaluate.questions_num}}</span>题</span>
            </div>
            <div class="desc" v-html="evaluate.desc" v-if="evaluate.desc">
            </div>
          </div>
        </div>
        <div class="row m-t-sm p-t-xs" v-show="loading === 0" style="min-height:300px;">
          <!-- 报告展示模板 -->
          <normal-tpl :code="code" :questionnaire="evaluate" :tester="tester" v-if=" loading === 0 && evaluate.report_type === 1"></normal-tpl>
          <dimension-tpl :code="code" :questionnaire="evaluate" :tester="tester" v-if=" loading === 0 && evaluate.report_type === 2"></dimension-tpl>
        </div>
        <div class="row p-t-b-md text-center">
          <router-link to="/evaluate" class="btn btn-md btn-primary">参与更多测评，完善个人档案 &gt;&gt;</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../../resource/evaluate";
import Loading from "../../blocks/loading.vue";
import NormalTpl from "./normal.vue";
import DimensionTpl from "./dimension.vue";

export default {
  name: "EvaluateReport",
  data: function() {
    return {
      loading: 1,
      evaluate: {},
      company: {},
      tester: {},
      code: ""
    };
  },
  components: {
    Loading,
    NormalTpl,
    DimensionTpl
  },
  watch: {
    // 监控数据
    evaluate: function(now, pre) {
      if (now.name !== pre.name) {
        document.title = `测评报告：${now.name}`;
      }
    }
  },
  created: function() {
    // 页面渲染完成后
    let that = this;
    Evaluate.questionnaire({ code: that.$route.params.code }).then(
      res => {
        const data = res.body;
        if (data.code === 0 || data.code === 4) {
          const rs = data.result;
          that.evaluate = rs.questionnaire;
          that.company = rs.company;
          that.tester = rs.tester || {};
          that.type = rs.category === "questionnaire" ? 1 : 2; // 问卷还是code
          // 设置code
          if (rs.code) {
            that.code = rs.code;
          }
          // 登录但没有权限
          if (data.code === 4) {
            that.code = that.$route.params.code;
            that.loading = 0;
            return;
          }
          if (rs.is_login === 1) {
            if (that.type === 1) {
              if (rs.status === 1) {
                // 问卷
                that.$router.replace({
                  name: "EvaluateShow",
                  params: { code: that.code }
                });
              } else {
                that.loading = 0;
              }
            } else {
              // 测评
              if (that.code === that.$route.params.code) {
                // 同一个测评
                if (rs.status === 1) {
                  that.$router.replace({
                    name: "EvaluateShow",
                    params: { code: that.code }
                  });
                } else {
                  that.loading = 0;
                }
              } else {
                //  非同一个测评
                if (rs.status > 1) {
                  // 结束测评
                  if (res.code === 0) {
                    // 正常用户
                    that
                      .$http({
                        method: "PUT",
                        url: `/evaluate/copy_evaluate`,
                        body: {
                          used_code: that.code,
                          unused_code: that.$route.params.code
                        }
                      })
                      .then(
                        res => {
                          let data = res.body;
                          if (data.code === 0) {
                            // 载入
                            that.code = that.$route.params.code;
                          } else {
                            // 异常跳转
                            alert(data.msg);
                            that.$router.replace({
                              name: "EvaluateShow",
                              params: { code: that.$route.params.code }
                            });
                          }
                        },
                        res => {
                          // 异常跳转
                          that.$router.replace({
                            name: "EvaluateShow",
                            params: { code: that.$route.params.code }
                          });
                        }
                      );
                  }
                } else {
                  // 未结束测评
                  that.$router.replace({
                    name: "EvaluateShow",
                    params: { code: that.$route.params.code }
                  });
                }
              }
            }
          } else {
            // 未登录无权限
            that.$router.replace({
              name: "EvaluateShow",
              params: { code: that.$route.params.code }
            });
          }
        } else {
          // 无权限
          that.$router.replace({ name: "EvaluateList" });
        }
        that.is_processing = 0;
      },
      res => {
        that.is_processing = 0;
      }
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#radar-area {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// show.vue?d6d8326c